import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isPortalAuthenticated } from '../services/portalAuth';
import { portalApi } from '../services/portalApi';
import './PortalLoginPage.css';

export default function PortalLoginPage() {
  const [email, setEmail]       = useState('');
  const [sent, setSent]         = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  if (isPortalAuthenticated()) return <Navigate to="/portal" replace />;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await portalApi.requestMagicLink(email.trim().toLowerCase());
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="portal-login-page">
      <div className="portal-login-card">
        <div className="plc-header">
          <p className="plc-company">Semper Gratus Inc.</p>
          <h1 className="plc-heading">Client Portal</h1>
          <p className="plc-sub">Secure, passwordless access to your contracts and invoices.</p>
        </div>

        {sent ? (
          <div className="plc-sent">
            <div className="plc-sent-icon" aria-hidden="true">✉</div>
            <h2>Check your inbox</h2>
            <p>We sent a login link to <strong>{email}</strong>. It's valid for 15 minutes.</p>
            <button className="plc-resend" onClick={() => setSent(false)}>Use a different email</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="plc-form">
            <label className="plc-label" htmlFor="portal-email">Email address</label>
            <input
              id="portal-email"
              type="email"
              className="plc-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              autoComplete="email"
              autoFocus
              required
            />
            {error && <p className="plc-error">{error}</p>}
            <button type="submit" className="plc-btn" disabled={loading}>
              {loading ? 'Sending…' : 'Send login link'}
            </button>
          </form>
        )}

        <p className="plc-note">
          No account? Contact us at <a href="mailto:hello@sempergratusinc.com">hello@sempergratusinc.com</a>
        </p>
      </div>
    </div>
  );
}
